import { Injectable, Injector } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../store-management/state/app-state';
import * as receiving from '../../shared/store-management/actions/receiving-action';
import { selectReceivingSucsess } from '../store-management/selectors/receiving.selector';
import { ReceivingBusinessService } from '../../receiving.service';
import { Observable, observable } from 'rxjs';
import { 
    SearchModel,
    ReceivingList,
    SortKeyObject,
    InvoiceModel,
    GetReceivingParamsDetaildById,
    PoSummary,
    PodetailModel,
    GetInventoryLookUp,
    SupplierListModel,
    SuplierViewList,
    MerchandiseArrivalHeaderDetail,
    LocationPayload,
    MerchandiseArrivalEntity,
    PostSavedMA,
    ReceivingPostModel
} from '../models';
import { ReceivingService } from './APIServices/ReceivingService';
import { ConfigurationService } from './configuration.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { RequestService } from 'src/app/shared/services/RequestServices/Request-Service';
import { PrevilegeAuthorizationService } from 'src/app/authorization/services/privilege-authorization.service';
import { InventoryLookUpPost, LookupConfigurationV2, SupplierItemLookUpPost } from 'src/app/shared/models/Inventory/InventoryLookUpEntity';
import { GlobalConversionService } from 'src/app/shared/services/GlobalMethodService/GlobalConversion-Service';


@Injectable({
    providedIn: 'root'
})
export class FacadeService {
    constructor(  private store: Store<AppState>, public injector: Injector) {}
    /**
     * @service receivingBusinessService;
     * @function getToken
     * @bing login screen
     */
    private  receivingBusinessService: ReceivingBusinessService;
    public get Receiving(): ReceivingBusinessService {
     if (!this.receivingBusinessService) {
        this.receivingBusinessService = this.injector.get(ReceivingBusinessService);
     }
     return this.receivingBusinessService;
    }

    /**
     * @service configurationservice
     * @description get All configuration
     */
    private  configurationService: ConfigurationService;
    public get ConfigurationService(): ConfigurationService {
    if (!this.configurationService) {
    this.configurationService = this.injector.get(ConfigurationService);
    }
    return this.configurationService;
    }

    /**
     * @service ReceivingService;
     */
    private  receivingService: ReceivingService;
    public get ReceivingService(): ReceivingService {
     if (!this.receivingService) {
        this.receivingService = this.injector.get(ReceivingService);
     }
     return this.receivingService;
    }
    /**
     * @service CommonService;
     */
     private  commonService: CommonService;
     public get CommonService(): CommonService {
      if (!this.commonService) {
         this.commonService = this.injector.get(CommonService);
      }
      return this.commonService;
     }
      /**
     * @service ReceivingService;
     */
       private  requestService: RequestService;
       public get RequestService(): RequestService {
        if (!this.requestService) {
           this.requestService = this.injector.get(RequestService);
        }
        return this.requestService;
       }
    /**
     * @service ReceivingService;
     */
            private authService: PrevilegeAuthorizationService;
            public get PrevilegeAuthorizationService(): PrevilegeAuthorizationService {
             if (!this.authService) {
                this.authService = this.injector.get(PrevilegeAuthorizationService);
             }
             return this.authService;
            }
                /**
     * @service ReceivingService;
     */
                 private GlobalService: GlobalConversionService;
                 public get GlobalConversionService(): GlobalConversionService {
                  if (!this.GlobalService) {
                     this.GlobalService = this.injector.get(GlobalConversionService);
                  }
                  return this.GlobalService;
                 }
    /**
     * 
     * @param siteId
     */
    getReceivingInvoice(requestParams?: any) {        
            return this.ReceivingService.GetInvoice(requestParams);
    }
     /**
     * 
     * @param siteId
     */
    GetPoDetailsById(PoModel: PodetailModel) {
        return this.ReceivingService.PoDetails(PoModel);
    }
    /**
     * 
     * @param siteId
     */
    GetInventoryLookUpByText(InventoryLookupModel: InventoryLookUpPost) {
        return this.ReceivingService.GetInventoryLookup(InventoryLookupModel);
    }

    GetInventoryLookUpByTextV2(InventoryLookupModel: LookupConfigurationV2) {
        return this.ReceivingService.GetInventoryLookupV2(InventoryLookupModel);
    }

    GetSupplierItemNumber(LookupModel: SupplierItemLookUpPost) {
        return this.ReceivingService.SearchBySupplierItemNumber(LookupModel);
      }
    /**
     * @param GetReceivingParamsDetaildById
     */
    getReceivingInvoiceDetailById(invoiceDetails: GetReceivingParamsDetaildById) {
    return this.ReceivingService.GetInvoiceDetails(invoiceDetails);
    }

    /**
     * @param GetReceivingParamsDetaildById
     */
    getReceivingPoSummary(PoSummaryModel: any) {
    return this.ReceivingService.GetPurchaseOrderSummary(PoSummaryModel);
    }
    /**
     *@function getReceiving() GetPOSummary;
    * @param none
    * @description Get ReceivingList
    */
    getReceiving(receivingParams: any) {
    this.Receiving.getReceivingList(receivingParams);
    }
    /**
     * @param none
     * @description Get ReceivingList
     * @function getReceivingSusessData
     */
    getReceivingSucessData(): Observable<ReceivingList[]> {
    return this.Receiving.getReceivingData();
    }
    /**
     *@function getReceivingDetail();
     * @param none
     * @description Get ReceivingList Detail View
     */
    getReceivingDetail(detailListParams: GetReceivingParamsDetaildById) {
        this.Receiving.getReceivingDetailView(detailListParams);
     }

    /**
     * 
     * @param siteId
     */
    getpoSummary(PosummaryModel: PoSummary) {
        return this.ReceivingService.GetPOSummary(PosummaryModel);
    }

    /**
     * 
     * @param siteId
     */
    GetSupplierList(SupplierModel: any) {
        return this.ReceivingService.GetSupplierList(SupplierModel);
    }

    GetPayTermById(payTermId: number) {
        return this.ReceivingService.GetPayTermById(payTermId);
    }

    clearReceivingsuccess() {
        this.Receiving.clearReceivinglanding();
    }

    /**
     * 
     * @param siteId
     */
    PostReceivingMa(merchandiseArrivalEntity: any) {
        return this.Receiving.postReceivingData(merchandiseArrivalEntity);
    }

    PostReceivingSaveMa(merchandiseArrivalEntity: any) {
        return this.Receiving.SaveReceivingData(merchandiseArrivalEntity);
    }
    /**
     *
     * @param siteId
     */
    GetLocationList(LocationModel: any) {
        return this.ReceivingService.GetLocation(LocationModel);
    }

    ReceivingPostMa(merchandiseArrivalEntity: ReceivingPostModel): Observable<any> {
        return this.ReceivingService.PostReceivingMA(merchandiseArrivalEntity);
    }
    ReceivingSaveMa(merchandiseArrivalEntity: ReceivingPostModel): Observable<any> {
        return this.ReceivingService.SaveReceivingMA(merchandiseArrivalEntity);
    }

    GetReceivingPostSuccess() {
        return this.Receiving.getReceivingPostSuccess();
    }
    GetReceivingSaveSuccess() {
        return this.Receiving.getReceivingSaveSuccess();
    }

    getAllSupplier(SupplierModel: any) {
      this.Receiving.getAllSupplierList(SupplierModel);
    }

    getLocation(locationModel: any) {
        this.Receiving.getAllLocationList(locationModel);
    }

    getSearchSuplier(suplierKey: any) {
        this.Receiving.getSearchSuplier(suplierKey);
    }

    getSuplierSearchList(): Observable<SuplierViewList[]> {
      return this.Receiving.getSuplierSearchList();
    }

    getReceivingDetailById(): Observable<MerchandiseArrivalHeaderDetail> {
        return this.Receiving.getReceivingDataDetail();
    }

    searchReceivingList(searchKey: SearchModel) {
        this.Receiving.searchReceivingList(searchKey);
    }

    searchReceivingSorting(sortingKey: SortKeyObject) {
        this.Receiving.searchReceivingSorting(sortingKey);
    }

    getlookUpDetailById(poModel: PodetailModel) {
        this.Receiving.getLookUpdetailById(poModel);
    }

    getlookUpByDetailSuccess(): Observable<MerchandiseArrivalHeaderDetail> {
        return this.Receiving.getLookupDetailSuccess();
    }

    getlookUpGridDetailSuccess(): Observable<any> {
      return this.Receiving.getlookupGridData();
    }
    getAllpoSummary(PosummaryModel: any): void {
        this.Receiving.getPoSummary(PosummaryModel);
    }

    searchitemList(searchParams: InventoryLookUpPost) {
      this.Receiving.itemsearchList(searchParams);
    }

    searchSupplieritemNumber(payload: SupplierItemLookUpPost) {
        this.Receiving.getsupplieritemNumberList(payload);
    }

    getitemlistSuccess(): any {
        return this.Receiving.getitemlistData();
    }

    GetSupplierItemNumberSuccess(): any {
        return this.Receiving.GetSupplierItemNumberSuccess();
    }
    addoptiontoGrid(item: any) {
        this.Receiving.addgridData(item);
    }

    claerallStoreData() {
        this.Receiving.clearstore();
    }
    claerPostAndSaveResponseStoreData() {
        this.Receiving.postAndSaveResponseStoreClear();
    }
    clearLookUpData(){
        this.Receiving.clearPostContinueStore();
    }
    clearitemlistdata() {
       this.Receiving.clearItemlistsearchdata();
    }
    disabledFormControls(controlData: any, exceptControl: any) {
        this.Receiving.disabledformControls( controlData, exceptControl);
    }
    getInventoryListcallback(InventoryResponse: any) {
        this.Receiving.getInventoryOfflineList(InventoryResponse);
    }
    getInvoiceOfflineData(responseofflineData) {
        this.Receiving.getInvoiceDetailsByIdoffline(responseofflineData);
    }
}